import { NgModule } from '@angular/core';
import { ReBuyComponent } from './re-buy.component';

@NgModule({
  declarations: [ReBuyComponent],
  exports: [ReBuyComponent],
})
export class ReBuyModule {}
